define(
  'trackerBreadcrumbShowCase',[

  ],
  () => {
    'use strict';

    const breadcrumbSection = document.querySelector('[data-breadcrumb-section]');

    /**
     * @private
     * trackBreadCrumbEvent: track events realted to breadcrumb in builder showcase.
     *
     * @param {Event} event with the information of click event
     */
    function trackBreadCrumbEvent(event) {
      const target = event.target.closest('[data-breadcrumb-item]') || event.target;

      if (!target.dataset.breadcrumbItem) {
        return;
      }

      const eventGa4 = {
        eventName: 'showcase_events',
        params: {
          click_target: 'Breadcrum clicked',
          click_target1: target.innerText
        },
        eventType: 'GA4Event'
      };
      document.body.dispatchEvent(new CustomEvent('trackOnDemandEvent', {
        detail: { data: eventGa4 }
      }));
    }

    if (breadcrumbSection) {
      breadcrumbSection.addEventListener('click', trackBreadCrumbEvent);
    }
  }
);

